import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet';
import './Navbar.css';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [menuOpen, setMenuOpen] = useState(false);
  const history = useHistory();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleNavLinkClick = () => {
    if (isMobile) {
      closeMenu();
    }
  };

  useEffect(() => {
    const unlisten = history.listen(() => {
      setMenuOpen(false);
    });

    return () => unlisten();
  }, [history]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <nav className={`navbar navbar-expand-lg  ${isMobile ? 'navbar-light' : 'navbar-dark'}`}>
        <div className="container_NAV ">
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded={menuOpen ? 'true' : 'false'}
            aria-label="Toggle navigation"
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className={`navbar-nav ${isMobile ? 'mobile-nav' : 'mr-auto'}`}>
              <NavItem href="/" label={t('Acceuil')} closeMenu={closeMenu} onClick={handleNavLinkClick}/>
              <NavItem href="/about_us" label={t('A Propos')} closeMenu={closeMenu} onClick={handleNavLinkClick}/>
              <NavItem href="/secteurs" label={t('Secteur d\'Intervention')} closeMenu={closeMenu} onClick={handleNavLinkClick}/>
              <NavDropdown label={t('Domaine d\'Application')} closeMenu={closeMenu} onClick={handleNavLinkClick} isMobile={isMobile}>
  <NavLinkItem href="/controlCND" closeMenu={closeMenu} onClick={handleNavLinkClick} isMobile={isMobile}>{t('Contrôle Non Destructif (CND)')}</NavLinkItem>
  <NavLinkItem href="/controlRSC" closeMenu={closeMenu} onClick={handleNavLinkClick} isMobile={isMobile}>{t('Réception et Suivi de Construction (RSC)')}</NavLinkItem>
  <NavLinkItem href="/controlCRS" closeMenu={closeMenu} onClick={handleNavLinkClick} isMobile={isMobile}>{t('Contrôle Réglementaire de Sécurité (CRS)')}</NavLinkItem>
</NavDropdown>
              <NavItem href="/control" label={t('Champ d\'Activités')} closeMenu={closeMenu} onClick={handleNavLinkClick}/>
              <NavItem href="/formation" label={t('Formation')} closeMenu={closeMenu} onClick={handleNavLinkClick}/>
              <NavItem href="/qualite" label={t('Qualité')} closeMenu={closeMenu} onClick={handleNavLinkClick}/>
              <NavItem href="/contact" label={t('Contact')} closeMenu={closeMenu} onClick={handleNavLinkClick}/>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

const NavItem = ({ href, label, closeMenu, onClick }) => (
  <li className="nav-item">
    <a
      href={href}
      className={`nav-link underline ${label === 'A Propos' ? 'nowrap' : ''}`}
      onClick={() => {
        closeMenu();
        onClick && onClick();
      }}
    >
      {label}
    </a>
  </li>
);

const NavDropdown = ({ label, children }) => (
  <li className="nav-item dropdown">
    <a className="nav-link dropdown-toggle underline" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {label}
    </a>
    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
      {children}
    </div>
  </li>
);

const NavLinkItem = ({ href, children, closeMenu, onClick, isMobile }) => (
  <a
    href={href}
    className="dropdown-item"
    onClick={() => {
      closeMenu();
      onClick && onClick();
    }}
  >
    {children}
  </a>
);

export default Navbar;
